import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import RefundsPage from './RefundsPage.vue'

export const refundsRoutes: RouteRecordRaw[] = [
  {
    path: routes.TREASURY_REFUND_REQUESTS,
    name: 'treasury.refunds',
    component: RefundsPage,
    meta: {
      layout: 'admin',
      requiresAuth: true,
      title: 'Refund approvals',
      activeMenu: 'Treasury',
    },
  },
]
